import { Map } from 'immutable';
import usdtRechargeReducer from './usdtRechargeReducer';
import expayRechargeReducer from './expayRechargeReducer';
import bironexRechargeReducer from './bironexRechargeReducer';
var initialState = Map({
    usdt: Map({
        fetching: null,
        usdtError: null,
        infoWallet: null,
        state: null
    }),
    expay: Map({
        fetching: null,
        refer: null,
        error: null,
        amount: null,
        createdAt: null,
        invoiceId: null,
        subToken: null,
        checkStatus: null,
        checking: false,
    }),
    bironex: Map({
        fetching: false,
        error: undefined,
        createError: undefined,
        amount: undefined,
        result: undefined,
    }),
});
export default (function (state, action) {
    if (state === void 0) { state = initialState; }
    state = state.update('usdt', function (br) { return usdtRechargeReducer(br, action); });
    state = state.update('expay', function (er) { return expayRechargeReducer(er, action); });
    state = state.update('bironex', function (br) { return bironexRechargeReducer(br, action); });
    return state;
});



// WEBPACK FOOTER //
// ./src/reducers/recharge/index.js